import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    scrollArea: {
      height: '100%',
      width: '100%',
      overflowY: 'scroll',
      scrollSnapType: 'y mandatory',
      overscrollBehavior: 'contain',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    slide: {
      position: 'relative',
      height: '100%',
      width: '100%',
      scrollSnapAlign: 'start',
      scrollSnapStop: 'always',
    },
    slideActionBar: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      padding: [Spacings.s48, Spacings.s12],
      paddingBottom: `max(${Spacings.s24}, env(safe-area-inset-bottom))`,
    },
  },
  { name: 'feed-slide-list' }
);

export default useStyles;
